'use strict';

import FeedItem from './feed_item'

class FeedDisplay extends HTMLElement {
  get src(){
    let s = this.getAttribute('src');
    let src = null
    if(s != undefined && s.length > 0 && s.match(/^http/)){
      src = s
    }
    if(src === null){ src = "https://www.wired.com/feed" }
    if(src !== null){ src = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURI(src)}` }

    return src
  }

  updateFeed(feed, cb=null) {
    this.feed = feed
    console.log('updateFeed')
    if(cb !== null){
      cb()
    }
  }

  nextIndex() {
    if(this._currentIndex === undefined){ this._currentIndex = -1 }
    this._currentIndex += 1
    this._currentIndex = this._currentIndex % this.feed.length
    console.log(this.feed.length)
    return this._currentIndex
  }

  showNextItem() {
    const data = this.feed[this.nextIndex()]
    console.log('currentItem', data, this.feed)
    const nextItem = document.createElement('feed-item')
    nextItem.text = data.title
    this.appendChild(nextItem)
    if(this.currentItem !== undefined){
      this.currentItem.classList.add('hidden')
      setTimeout(() => {
        this.previousItem.remove()
      }, 4000)
    }
    this.previousItem = this.currentItem
    this.currentItem = nextItem
    setTimeout(() => {this.showNextItem()}, 5000)
  }

  parseFeed(xmlHttp, cb=null) {
    console.log('parseFeed')
    if(xmlHttp.readyState == 4 && xmlHttp.status == 200){
      const response = JSON.parse(xmlHttp.response)
      const feed = response.items
      const updatedAt = feed[0].pubDate
      console.log(updatedAt, this.updatedAt === null, this.updatedAt < updatedAt)
      if(this.updatedAt === null || this.updatedAt < updatedAt){
        this.updatedAt = updatedAt
        this.updateFeed(feed, cb)
      }
    }

    setTimeout(() => this.fetchSrc, 100000)
  }

  fetchSrc(cb=null) {
    const xmlHttp = new XMLHttpRequest()
    xmlHttp.onreadystatechange = () => this.parseFeed(xmlHttp, cb)
    xmlHttp.open("GET", this.src, true)
    xmlHttp.send(null)
  }

  attachedCallback() {
    console.log({source: this.src})
    this.updatedAt = null
    this.fetchSrc(() => {this.showNextItem()})
  }
}

document.registerElement('feed-display', FeedDisplay)

export default FeedDisplay
